import { endOfToday, startOfToday, subDays, subMonths, subYears } from "date-fns"

import dayjs from "libs/dayjs"

export enum EnumTimePeriod {
  today = "today",
  yesterday = "yesterday",
  thisWeek = "thisWeek",
  lastWeek = "lastWeek",
  thisMonth = "thisMonth",
  lastMonth = "lastMonth",
  last30Days = "last30Days",
  last6Months = "last6Months",
  last12Months = "last12Months",
  thisYear = "thisYear",
  lifetimeSystem = "lifetimeSystem",
  thisQuarter = "thisQuarter",
  custom = "custom"
}
const timePeriodOptionLabel = (v: EnumTimePeriod) => {
  return `timePeriod.${v}`
}
export const TimePeriodOptions = Object.keys(EnumTimePeriod).map((period) => ({
  name: timePeriodOptionLabel(period as EnumTimePeriod),
  value: period
}))

const systemLaunch = dayjs(process.env.REACT_APP_LAUNCH_DATE || "01.01.2020", "DD.MM.YYYY").toDate()
export const getTimePeriod = (v: EnumTimePeriod): Date[] => {
  const now = new Date()
  const endOfNow = dayjs().endOf("day").toDate()
  switch (v) {
    case EnumTimePeriod.lifetimeSystem:
      return [systemLaunch, endOfNow]
    case EnumTimePeriod.today:
      return [dayjs().startOf("day").toDate(), endOfNow]
    case EnumTimePeriod.yesterday:
      return [dayjs().subtract(1, "day").startOf("day").toDate(), dayjs().subtract(1, "day").endOf("day").toDate()]
    case EnumTimePeriod.thisWeek:
      return [dayjs().startOf("isoWeek").toDate(), endOfNow]
    case EnumTimePeriod.lastWeek:
      return [dayjs().startOf("isoWeek").subtract(1, "week").toDate(), dayjs().startOf("isoWeek").toDate()]
    case EnumTimePeriod.thisMonth:
      return [dayjs().startOf("month").toDate(), endOfNow]
    case EnumTimePeriod.lastMonth:
      return [dayjs().startOf("month").subtract(1, "month").toDate(), dayjs().startOf("month").toDate()]
    case EnumTimePeriod.thisQuarter:
      return [dayjs().startOf("quarter").startOf("day").toDate(), endOfNow]
    case EnumTimePeriod.thisYear:
      return [dayjs().startOf("year").toDate(), endOfNow]
    case EnumTimePeriod.last30Days:
      return [dayjs().startOf("day").subtract(1, "month").toDate(), endOfNow]
    case EnumTimePeriod.last12Months:
      return [dayjs().startOf("day").subtract(12, "month").toDate(), endOfNow]
    case EnumTimePeriod.last6Months:
      return [dayjs().subtract(6, "months").toDate(), endOfNow]
    case EnumTimePeriod.custom:
      return [now, now]
    default:
      return [new Date(0), endOfNow]
  }
}

export const getLimitedTimeframeOptions = () => [
  {
    label: "timePeriod.allTime",
    start: new Date(2000, 0, 1),
    end: endOfToday()
  },
  {
    label: "timePeriod.today",
    start: startOfToday(),
    end: endOfToday()
  },
  {
    label: "timePeriod.yesterday",
    start: subDays(startOfToday(), 1),
    end: subDays(endOfToday(), 1)
  },
  {
    label: "timePeriod.last7Days",
    start: subDays(startOfToday(), 6),
    end: endOfToday()
  },
  {
    label: "timePeriod.last1Month",
    start: subMonths(startOfToday(), 1),
    end: endOfToday()
  },
  {
    label: "timePeriod.last3Months",
    start: subMonths(startOfToday(), 3),
    end: endOfToday()
  },
  {
    label: "timePeriod.last6Months",
    start: subMonths(startOfToday(), 6),
    end: endOfToday()
  },
  {
    label: "timePeriod.lastYear",
    start: subYears(startOfToday(), 1),
    end: endOfToday()
  }
]
